module.exports = __webpack_public_path__ + "img/question_mark.dd03b04b.png";